import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./language/en.json";
import ar from "./language/ar.json";

const resources = {
  en,
  ar,
};

export const availableLanguages = Object.keys(resources);

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  defaultNS: "common",
  fallbackLng: "en",
  returnNull: false,
});
